import axios from "axios";
import dayjs, { Dayjs } from "dayjs";
import { changeTenantSettings } from "./store/slice/auth";
const MAX_CACHE_SIZE = 25;
const MAX_CACHE_AGE = {
    minutes: 15
};
const settingsCache = new Map();
const resizeCache = (spareCapacity = 1) => {
    while (settingsCache.size >= Math.max(MAX_CACHE_SIZE - spareCapacity, 0)) {
        let oldestInsertTime = null;
        let oldestTenantId = null;
        for (let [key, value] of settingsCache.entries()) {
            if (oldestInsertTime == null || oldestTenantId == null) {
                oldestInsertTime = value.insertTime;
                oldestTenantId = key;
            }
            else {
                if (value.insertTime.isBefore(oldestInsertTime)) {
                    oldestInsertTime = value.insertTime;
                    oldestTenantId = key;
                }
            }
        }
        settingsCache.delete(oldestTenantId);
    }
};
const invalidateCache = () => {
    settingsCache.clear();
};
const invalidateCacheForTenant = (tenantId) => {
    settingsCache.delete(tenantId);
};
const refreshSettingsForTenant = (tenantId, dispatch) => {
    invalidateCacheForTenant(tenantId);
    return getSettingsForTenant(tenantId, dispatch);
};
const getSettingsForTenant = (tenantId, dispatch) => {
    return new Promise((resolve, reject) => {
        const cacheRecord = settingsCache.get(tenantId);
        const complete = (tenantSettings) => {
            resolve(tenantSettings);
            if (dispatch) {
                dispatch(changeTenantSettings(tenantSettings));
            }
        };
        if (cacheRecord) {
            if (cacheRecord.insertTime.add(dayjs.duration(MAX_CACHE_AGE)).isAfter(dayjs())) {
                complete(cacheRecord.settings);
                return;
            }
            else {
                settingsCache.delete(tenantId);
            }
        }
        axios.get(`/admin/v1/tenants/${tenantId}/settings`)
            .then((response) => {
            resizeCache();
            settingsCache.set(tenantId, {
                settings: response.data,
                insertTime: dayjs()
            });
            complete(response.data);
        })
            .catch(reject);
    });
};
export default {
    getSettingsForTenant,
    refreshSettingsForTenant,
    invalidateCache,
    invalidateCacheForTenant,
};
